import React from 'react';
import { Card, Table } from 'antd';
import type { GameMetrics } from '../../../../stores/labatt-game';
import style from '../../style.module.scss';

interface GamePerformanceTableProps {
    games: GameMetrics[];
}

const sortGamesByRankOrTotalPlays = (games: GameMetrics[]): GameMetrics[] => {
    return games.slice().sort((a, b) => {
        if (a.rank && b.rank) {
            return a.rank - b.rank;
        }
        if (a.rank) return -1;
        if (b.rank) return 1;
        return b.totalPlays - a.totalPlays;
    });
};

const RANK_EMOJI_MAP: Record<number, string> = {
    1: '🥇',
    2: '🥈',
    3: '🥉',
};

const renderRankCell = (_: unknown, record: GameMetrics, index: number) => {
    const rank = record.rank || index + 1;
    const emoji = RANK_EMOJI_MAP[rank];
    return <span>{emoji ? emoji : rank}</span>;
};

const renderAveragePlaysPerUserCell = (_: unknown, record: GameMetrics) =>
    record.avgPlaysPerUser.toFixed(1);

const columns = [
    {
        title: 'Rank',
        key: 'rank',
        width: 80,
        render: renderRankCell,
    },
    {
        title: 'Game',
        dataIndex: 'gameName',
        key: 'gameName',
    },
    {
        title: 'Total Plays',
        dataIndex: 'totalPlays',
        key: 'totalPlays',
        align: 'right' as const,
    },
    {
        title: 'Unique Users',
        dataIndex: 'uniquePlayers',
        key: 'uniquePlayers',
        align: 'right' as const,
    },
    {
        title: 'Avg Plays/User',
        key: 'avgPlaysPerUser',
        align: 'right' as const,
        render: renderAveragePlaysPerUserCell,
    },
];

export const GamePerformanceTable: React.FC<GamePerformanceTableProps> = ({
    games,
}) => {
    return (
        <div className={style.table_containers}>
            <h1>Game Performance</h1>
            <Card className={style.game_performance_card}>
                <Table
                    dataSource={sortGamesByRankOrTotalPlays(games)}
                    rowKey="gameId"
                    pagination={false}
                    columns={columns}
                />
            </Card>
        </div>
    );
};
